'use strict';

import modalDirective from '../../rest-modal';

export default modalDirective({});
